import { isEqual, noop } from 'lodash/fp';
import { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { SearchType } from '@mews-commander/enums';
import { getError } from '@mews-commander/legacy-form';
import { SearchResult } from '@mews-commander/types';
import { openModal } from '../../modules/app/actions/common';
import {
    clearSelectedSearchResult,
    preselectSearchResult,
    resetSearch,
    selectSearchResult,
} from '../../modules/search/actions';
import Search from '../../modules/search/components/Search';
import { getSearchResultInteractiveDetail } from '../../modules/search/getSearchResultInteractiveDetail';
import { getSelectedSearchResult } from '../../modules/search/selectors';

interface OwnProps {
    input?: $TSFixMe; // TODO: pt.shape(fieldInputPropTypes) from redux-form
    meta?: $TSFixMe; // TODO: pt.shape(fieldMetaPropTypes) from redux-form
    searchTypes: SearchType[];
    selectedResult?: SearchResult | null;
    selectResult?: $TSFixMeFunction;
    clearResult?: $TSFixMeFunction;
    preselectedResult?: {
        id?: string;
        searchType?: string;
    };
    preselectResult?: $TSFixMeFunction;
    createNewEntity?: $TSFixMeFunction;
    clearOnSelection?: boolean;
    onResultClick?: $TSFixMeFunction;
    onResultClear?: () => void;
    'data-test-id'?: string;
}

type Props = OwnProps & typeof SearchFormFieldRenderer.defaultProps;

class SearchFormFieldRenderer extends Component<Props> {
    static defaultProps = {
        clearOnSelection: false,
        onResultClick: noop,
    };

    componentDidMount() {
        const { preselectedResult, preselectResult, input, meta } = this.props;
        if (!meta.dirty && preselectedResult && preselectedResult.id) {
            // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
            preselectResult(preselectedResult).then(() => input.onChange(preselectedResult));
        }
    }

    componentDidUpdate(prevProps: Props) {
        const { input: prevInput } = prevProps;
        const { input, meta, preselectedResult, preselectResult, clearResult, selectedResult } = this.props;
        if (meta.touched && !input.value && selectedResult) {
            // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
            clearResult();
        }

        if (!isEqual(prevProps.preselectedResult, preselectedResult)) {
            if (preselectedResult && preselectedResult.id) {
                // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
                preselectResult(preselectedResult).then(() => input.onChange(preselectedResult));
            } else {
                // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
                clearResult();
            }
        }

        if (!meta.touched && !input.value && !!prevInput.value) {
            // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
            clearResult();
        }
    }

    handleClearResult = () => {
        const { onResultClear } = this.props;
        if (onResultClear) {
            onResultClear?.();
        }
        // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
        this.props.clearResult();
        this.props.input.onChange(null);
    };

    handleResultClick = (result: $TSFixMe) => {
        const { onResultClick, clearOnSelection, input, selectResult } = this.props;
        // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
        selectResult(result);
        onResultClick(result);
        if (clearOnSelection) {
            this.handleClearResult();
        } else {
            input.onChange(result);
        }
    };

    handleSelectResult = (result: $TSFixMe) => {
        // @ts-expect-error $TSFixMeError: Property 'newEntity' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
        const { newEntity, createNewEntity } = this.props;
        if (result.id) {
            this.handleResultClick(result);
        } else if (newEntity) {
            // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
            createNewEntity(result);
        }
    };
    componentWillUnmount() {
        // @ts-expect-error $TSFixMeError: Property 'resetSearchScope' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
        const { resetSearchScope } = this.props;
        resetSearchScope();
    }
    render() {
        const { input, meta, searchTypes, ...other } = this.props;

        return (
            // @ts-expect-error $TSFixMeError: Type '{ error: Element | null; onResultClick: (result: any) => void; onResultClear: () => void; searchTypes: any[] | und...
            <Search
                {...other}
                error={getError(meta)}
                onResultClick={this.handleSelectResult}
                onResultClear={this.handleClearResult}
                searchTypes={searchTypes}
                data-test-id={this.props['data-test-id'] ?? input?.name}
            />
        );
    }
}

const ConnectedSearchFormFieldRenderer = connect(
    createStructuredSelector({
        // @ts-expect-error $TSFixMeError: No overload matches this call.
        selectedResult: getSelectedSearchResult,
    }),
    // @ts-expect-error $TSFixMeError: Property 'scope' does not exist on type '{}'.
    (dispatch, { scope, enterpriseId, optionalSearchParams, onOpenResult }) => ({
        selectResult: (selectedResult: $TSFixMe) => dispatch(selectSearchResult({ selectedResult }, scope)),
        clearResult: () => dispatch(clearSelectedSearchResult(scope)),
        preselectResult: ({ searchType, ...preselectedResult }: $TSFixMe) =>
            dispatch(
                // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe) => Promise<void>' is not assignable to parameter of type 'Act...
                preselectSearchResult(
                    {
                        enterpriseId,
                        optionalParams: optionalSearchParams,
                        searchTypes: [searchType],
                        ...preselectedResult,
                    },
                    scope
                )
            ),
        openSelectedResult: (url: string) => {
            onOpenResult?.();
            // @ts-expect-error $TSFixMeError: Argument of type 'ThunkAction<Action<any>, void, ApplicationState>' is not assignable to parameter of type 'Action<any>'...
            return dispatch(openModal(url));
        },
        resetSearchScope: () => dispatch(resetSearch(scope)),
    }),
    ({ selectedResult, ...otherStateProps }, { openSelectedResult, ...otherDispatchProps }, ownProps) => ({
        ...otherDispatchProps,
        ...ownProps,
        ...otherStateProps,
        selectedResult,
        ...getSearchResultInteractiveDetail({ searchResult: selectedResult, handler: openSelectedResult }),
    })
)(SearchFormFieldRenderer);

export default ConnectedSearchFormFieldRenderer;
